// Money formatting shared by the provider board. Keep the paise on small
// figures — a ₹3.54 lookup must not read as "₹4".
export const fmt = (n) =>
  n === null || n === undefined ? "—" : Number(n).toLocaleString("en-IN");

export const inr = (n) => {
  const v = Number(n || 0);
  return v >= 100
    ? Math.round(v).toLocaleString("en-IN")
    : (Math.round(v * 100) / 100).toLocaleString("en-IN");
};

// 3848 weeks of cover is noise, not information.
export const cover = (weeks) =>
  weeks == null ? null : weeks > 52 ? "over a year" : `${weeks} weeks`;

export const ROLE_STYLE = {
  primary: "bg-emerald-600 text-white",
  secondary: "bg-sky-100 text-sky-700 border border-sky-200",
  third: "bg-slate-100 text-slate-600 border border-slate-200",
  fourth: "bg-slate-100 text-slate-600 border border-slate-200",
  off: "bg-white text-slate-400 border border-dashed border-slate-300",
  standalone: "bg-indigo-50 text-indigo-700 border border-indigo-200",
};

export const ROLE_LABEL = {
  primary: "Primary",
  secondary: "Backup",
  third: "3rd in line",
  fourth: "4th in line",
  off: "Not in chain",
  standalone: "Standalone",
};

export const STATE_STYLE = {
  live: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partial: "bg-amber-50 text-amber-700 border-amber-200",
  pending: "bg-slate-50 text-slate-500 border-slate-200",
  standby: "bg-slate-50 text-slate-500 border-slate-200",
};

export const STATE_LABEL = {
  live: "Live",
  partial: "Incomplete data",
  pending: "Pending activation",
  standby: "Standby",
};

export const day = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short" })
    : null;

export const calls = (n) => `${fmt(n)} ${Number(n) === 1 ? "call" : "calls"}`;
